import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import './SummerTrips.scss';

const images = [
  'https://cdn.pixabay.com/photo/2019/08/22/08/12/bielsko-biala-4422883_1280.jpg',
  'https://slaskie.travel/Media/Default/.MainStorage/Article/bgx2erby.zr5/Enduro%20Trails%20BB2%20fot.%20Lucjusz%20Cykarski,%20Maciej%20Kopaniecki.jpg',
  'https://bi.im-g.pl/im/96/31/1c/z29563030AMP,Pogladowa-wizualizacja-ulic-3-Maja-i-Zamkowej--zap.jpg',
  'https://bauren.pl/wp-content/uploads/2008/09/Marlena_Faerber_Bauren_Hala_Sportowa_Bielsko038.jpg',
  'https://bauren.pl/wp-content/uploads/2008/09/Marlena_Faerber_Bauren_Hala_Sportowa_Bielsko024.jpg',
  'https://beskidzkieapartamenty.pl/wp-content/uploads/2018/01/beskidzkie-5.jpeg',
  'https://beskidzkieapartamenty.pl/wp-content/uploads/2018/01/beskidzkie-3.jpeg',
  'https://www.whitemad.pl/wp-content/uploads/2023/03/Willa-Sixta-fot.-Krzysztof-Morcinek-materialy-BWA.jpg',
  'https://www.whitemad.pl/wp-content/uploads/2023/03/Uliczki-starowki.-Fot.-Lucjusz-Cykarski.jpg',
  'https://www.super-nowa.pl/kultura-cat/miniatury/CR_0_b0a9f11061d89b916de8b5dbc387fccd.jpg',
  'https://trasynawczasy.pl/36-large_default/szyndzielnia-i-klimczok-z-bielska-bialej-do-szczyrku.jpg',
  'https://polskazachwyca.pl/wp-content/uploads/2019/06/Zapora-Por%C4%85bka.-Fot.-Janericloebe-1392x928.jpg',
  'https://bi.im-g.pl/im/e1/75/1a/z27746273AMP,Cavatina-Hall-w-Bielsku-Bialej.jpg',
  'https://polskazachwyca.pl/wp-content/uploads/2018/06/g%C3%B3ra-%C5%BCar-beskid-ma%C5%82y-shutterstock_199305311.jpg',
  'https://polskazachwyca.pl/wp-content/uploads/2018/06/jezioro-mi%C4%99dzybrodzkie-mi%C4%99dzybrodzie-zywieckie-shutterstock_697113907.jpg',
  'https://polskazachwyca.pl/wp-content/uploads/2019/06/Dom-Tkacza-w-Bielsku-Bia%C5%82ej.-Fot.-Alicja-Migda%C5%82-Drost-Muzeum-w-Bielsku-Bia%C5%82ej-CC-BY-SA-2.5.jpg',
];

const benefits = [
  {
    icon: 'fa-hotel',
    title: 'Premium Accommodation',
    description: 'Comfortable hotels in the heart of the city with all amenities included.'
  },
  {
    icon: 'fa-utensils',
    title: 'Delicious Cuisine',
    description: 'Experience authentic European cuisine with meals tailored to athletes.'
  },
  {
    icon: 'fa-volleyball-ball',
    title: 'Elite Training',
    description: 'Train in professional facilities and compete against top European teams.'
  },
  {
    icon: 'fa-bus',
    title: 'Full Transportation',
    description: 'Seamless transport to all venues, attractions, and neighboring cities.'
  },
  {
    icon: 'fa-map-marked-alt',
    title: 'Cultural Excursions',
    description: 'Explore historic cities: Krakow, Vienna, Prague, Bratislava, Budapest.'
  },
  {
    icon: 'fa-users',
    title: 'Team Building',
    description: 'Create lifelong friendships and memories with fellow athletes.'
  }
];

const destinations = [
  { city: 'Krakow', country: 'Poland', distance: '80 km', icon: 'fa-landmark' },
  { city: 'Vienna', country: 'Austria', distance: '300 km', icon: 'fa-music' },
  { city: 'Prague', country: 'Czech Republic', distance: '350 km', icon: 'fa-chess-rook' },
  { city: 'Bratislava', country: 'Slovakia', distance: '200 km', icon: 'fa-flag' },
  { city: 'Budapest', country: 'Hungary', distance: '400 km', icon: 'fa-water' }
];


const SummerTrips = () => {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const openLightbox = index => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div className="summer-trips">
      {/* Hero Section */}
      <section className="trips__hero">
        <div className="trips__hero-content">
          <span className="trips__hero-badge">
            <i className="fas fa-plane" /> Summer 2027
          </span>
          <h1 className="trips__hero-title">
            European College<br />
            <span>Summer Trip</span>
          </h1>
          <p className="trips__hero-subtitle">
            An unforgettable sports adventure in the heart of Europe. 
            Train with elite athletes, explore historic cities, and create memories that last a lifetime.
          </p>
          <div className="trips__hero-actions">
            <a href="mailto:contact@playsportusa.com" className="trips__btn trips__btn--primary">
              <i className="fas fa-envelope" /> Inquire Now
            </a>
            <a href="#gallery" className="trips__btn trips__btn--secondary">
              <i className="fas fa-images" /> View Gallery
            </a>
          </div>
        </div>
        <div className="trips__hero-stats">
          <div className="trips__hero-stat">
            <span className="trips__hero-stat-number">10+</span>
            <span className="trips__hero-stat-label">Days of Adventure</span>
          </div>
          <div className="trips__hero-stat">
            <span className="trips__hero-stat-number">5</span>
            <span className="trips__hero-stat-label">European Cities</span>
          </div>
          <div className="trips__hero-stat">
            <span className="trips__hero-stat-number">100%</span>
            <span className="trips__hero-stat-label">Organized For You</span>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="trips__benefits">
        <h2 className="trips__section-title">Everything Included</h2>
        <p className="trips__section-subtitle">
          We take care of every detail so you can focus on what matters most – 
          the sport, the experience, and the adventure.
        </p>
        <div className="trips__benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="trips__benefit">
              <div className="trips__benefit-icon">
                <i className={`fas ${benefit.icon}`} />
              </div>
              <h3 className="trips__benefit-title">{benefit.title}</h3>
              <p className="trips__benefit-desc">{benefit.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Destination Section */}
      <section className="trips__destination">
        <div className="trips__destination-content">
          <h2 className="trips__section-title">Your European Base</h2>
          <h3 className="trips__destination-city">Bielsko-Biała, Poland</h3>
          <p className="trips__destination-desc">
            Nestled in the picturesque Beskid Mountains, Bielsko-Biała is the perfect 
            base for your European adventure. This charming city of 170,000 offers 
            world-class sports facilities, stunning natural beauty, and easy access 
            to Central Europe's most iconic destinations.
          </p>
          <p className="trips__destination-desc">
            Known as a hub for professional volleyball, Bielsko-Biała provides an 
            elite sports experience while offering the warmth and hospitality that 
            Poland is famous for.
          </p>
          <div className="trips__destinations-list">
            <h4>Day Trips Available:</h4>
            <div className="trips__destinations-grid">
              {destinations.map((dest, index) => (
                <div key={index} className="trips__destination-item">
                  <i className={`fas ${dest.icon}`} />
                  <div>
                    <strong>{dest.city}</strong>
                    <span>{dest.country} • {dest.distance}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="trips__gallery" id="gallery">
        <h2 className="trips__section-title">Explore the Region</h2>
        <p className="trips__section-subtitle">
          Click on any image to see it in full size
        </p>
        <div className="trips__gallery-grid">
          {images.slice(0, 12).map((image, index) => (
            <div 
              key={index} 
              className="trips__gallery-item"
              onClick={() => openLightbox(index)}
            >
              <img src={image} alt={`Bielsko-Biała ${index + 1}`} />
              <div className="trips__gallery-overlay">
                <i className="fas fa-search-plus" />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Video Section */}
      <section className="trips__videos">
        <h2 className="trips__section-title">See It In Action</h2>
        <div className="trips__videos-grid">
          <a 
            href="https://youtu.be/em4CJIHrgjc" 
            target="_blank" 
            rel="noopener noreferrer"
            className="trips__video-card"
          >
            <div className="trips__video-icon">
              <i className="fab fa-youtube" />
            </div>
            <div className="trips__video-info">
              <h4>City Tour Video</h4>
              <span>English Version • 3 min</span>
            </div>
            <i className="fas fa-external-link-alt trips__video-link" />
          </a>
          <a 
            href="https://youtu.be/VyEKaBJsYhM" 
            target="_blank" 
            rel="noopener noreferrer"
            className="trips__video-card"
          >
            <div className="trips__video-icon">
              <i className="fab fa-youtube" />
            </div>
            <div className="trips__video-info">
              <h4>Sports Facilities Tour</h4>
              <span>Highlights • 5 min</span>
            </div>
            <i className="fas fa-external-link-alt trips__video-link" />
          </a>
        </div>
      </section>

      {/* CTA Section */}
      <section className="trips__cta">
        <h2>Ready for the Adventure of a Lifetime?</h2>
        <p>
          Limited spots available for Summer 2027. Contact us today to secure your team's place 
          on this unforgettable European journey.
        </p>
        <div className="trips__cta-actions">
          <a href="mailto:contact@playsportusa.com" className="trips__btn trips__btn--primary trips__btn--large">
            <i className="fas fa-paper-plane" /> Request Information
          </a>
          <a href="tel:+48794024963" className="trips__btn trips__btn--outline">
            <i className="fas fa-phone" /> Call Us: (+48) 794 024 963
          </a>
        </div>
      </section>

      {/* Lightbox */}
      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % images.length)
          }
        />
      )}
    </div>
  );
};

export default SummerTrips;
